import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    if (isHome) {
      const handleScroll = () => {
        setScrolled(window.scrollY > 50);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    } else {
      // Em páginas internas, iniciar com estilo "scrolled" (links pretos, logo preta)
      setScrolled(true);
    }
  }, [isHome]);

  const closeNavbar = () => {
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, { toggle: false });
      bsCollapse.hide();
    }
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-custom ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <a className="navbar-brand" href="/#home">
          <img 
            src={scrolled ? "/img/logo_sustenta_preto.png" : "/img/logo_sustenta_branco.png"} 
            alt="Sustenta LED - Distribuidora de LED, Importadora de Lâmpadas LED e Atacadista de Luminárias LED" 
          />
        </a>
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="/#home" onClick={closeNavbar}>Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#sobre-a-sustentaled" onClick={closeNavbar}>Sobre Nós</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#comotrabalhamos" onClick={closeNavbar}>Como Trabalhamos</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#produtos" onClick={closeNavbar}>Produtos</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#cases" onClick={closeNavbar}>Cases</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#faq" onClick={closeNavbar}>FAQ</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#contact" onClick={closeNavbar}>Contato</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;